'use client';
import classNames from 'classnames';
import { useRef, useState } from 'react';

import { IsGuestTooltip, IsUserTooltip, useUserStore } from '@/features/user';
import { Icon } from '@/shared/ui';
import { useMenuStore } from '@/widgets/menu/model/store';

import styles from './userToggle.module.scss';

export const UserToggle = () => {
  const [active, setActive] = useState(false);
  const { isAuth } = useUserStore();
  const { toggle: toggleMenu, isOpen: isMenuOpen } = useMenuStore();
  const ref = useRef<HTMLDivElement>(null);

  const toggle = () => {
    if (active && isMenuOpen) {
      toggleMenu();
    }
    setActive((prev) => !prev);
  };

  return (
    <div
      ref={ref}
      className={classNames(styles.toggle, active && styles['toggle--active'])}
    >
      <button
        className={styles.toggle__btn}
        title="Пользователь"
        onClick={toggle}
      >
        <Icon name="user" />
      </button>
      {isAuth ? (
        <IsUserTooltip
          className={styles.toggle__tooltip}
          isActive={active}
          onClose={toggle}
        />
      ) : (
        <IsGuestTooltip
          className={styles.toggle__tooltip}
          isActive={active}
          onClose={toggle}
        />
      )}
    </div>
  );
};
